<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')">首页</a-breadcrumb-item>
      <a-breadcrumb-item href="" @click.native="() => $router.go(-1)">确认预约</a-breadcrumb-item>
      <a-breadcrumb-item>预约须知</a-breadcrumb-item>
    </a-breadcrumb>

    <div id="info">
      <p style="text-align: center; font-size: 20px; font-weight: bold; line-height: 150%;">
        预约挂号须知
      </p>

      <p style="line-height: 150%">各位病友：</p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;
        感谢您选择来我院就诊，为保证您顺利就诊，请您认真阅读并充分理解以下规则，选择同意接受或不同意接受：
      </p>

      <p style="line-height: 150%; color: red;">
        &nbsp;&nbsp;&nbsp;根据浙医保发【2025】33号文件要求，2026年3月20日起，挂号费按新标准执行。
      </p>
      <p style="line-height: 150%; color: red;">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、取消双休日/节假日普通门诊加收费用（2元）
      </p>
      <p style="line-height: 150%; color: red;">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、门诊诊查费调整如下，其中中医科包含中医辨证论治费：
      </p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;普通门诊：15.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中医普通门诊：25.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;儿科普通门诊：25.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;副高门诊：25.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中医副高门诊：40.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;儿科副高门诊：35.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;正高门诊：30.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中医正高门诊：50.3元</p>
      <p style="line-height: 150%; color: red;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;儿科正高门诊：40.3元</p>

      <p
        class="MsoListParagraph"
        style="
          margin-top: 10px;
          margin-right: 0;
          margin-bottom: 10px;
          margin-left: 28px;
          line-height: 150%;
        "
      >
        <strong><span style="color: red">一、重点提醒</span></strong>
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如您发热症状或体温 ≥ 37.5℃，请至发热门诊就诊。我院【紫金港院区】与【玉泉院区】均开设24小时发热门诊，其他院区暂未开设。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;腹泻患者5月1日- 10月31日期间请至肠道门诊就诊。我院【紫金港院区】与【玉泉院区】均开设24小时肠道门诊，其他院区暂未开设。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请做好个人防护，全程佩戴口罩，感谢您的配合；
      </p>

      <p
        class="MsoListParagraph"
        style="
          margin-top: 10px;
          margin-right: 0;
          margin-bottom: 10px;
          margin-left: 28px;
          line-height: 150%;
        "
      >
        <strong><span style="color: red">二、就医规则</span></strong>
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.实名制就医：我院实行实名制预约挂号，请您准确提供姓名、身份证号码等，确保手机号码使用通畅，以便医生出诊时间有变动时与您联系。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.预约就诊制：所有号源提前7天开放（提前7天凌晨零点开始预约）。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.分时段就诊：请您根据预约号就诊时间，提前到院等候就诊。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.外地牌照车辆：支付宝搜索“非浙A急事通”，可申请在杭州“错峰出行”时段、区域内通行。
      </p>

      <p
        class="MsoListParagraph"
        style="
          margin-top: 10px;
          margin-right: 0;
          margin-bottom: 10px;
          margin-left: 28px;
          line-height: 150%;
        "
      >
        <strong><span style="color: red">三、在线建档</span></strong>
      </p>
      <p class="MsoListParagraph" style="margin-left: 28px; line-height: 150%">
        &nbsp;&nbsp;&nbsp;1.浙江大学医院/浙大二院微信公众号支持未建档就诊人（未分配医院病案号）在线建档、预约挂号；
      </p>
      <p class="MsoListParagraph" style="margin-left: 28px; line-height: 150%">
        &nbsp;&nbsp;&nbsp;2.首次来院的医保患者线上预约成功后，请于就诊日当天先至人工窗口医保关联。
      </p>

      <p
        class="MsoListParagraph"
        style="
          margin-top: 10px;
          margin-right: 0;
          margin-bottom: 10px;
          margin-left: 28px;
          line-height: 150%;
        "
      >
        <strong><span style="color: red">四、预约取号</span></strong>
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;就诊日当天可在自助机上取号，（医保患者请使用医保卡或者国家医保电子凭证取号，自费患者请使用身份证取号）。
      </p>

      <p
        class="MsoListParagraph"
        style="
          margin-top: 10px;
          margin-right: 0;
          margin-bottom: 10px;
          margin-left: 28px;
          line-height: 150%;
        "
      >
        <strong><span style="color: red">五、取消预约</span></strong>
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;就诊日当天上午7：00之前可在线取消预约。
      </p>

      <p
        class="MsoListParagraph"
        style="
          margin-top: 10px;
          margin-right: 0;
          margin-bottom: 10px;
          margin-left: 28px;
          line-height: 150%;
        "
      >
        <strong><span style="color: red">六、温馨提醒</span></strong>
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.初诊且未做过相关检查的病人，建议先看普通门诊。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.请按预约候诊时间到院候诊，取号截止时间：就诊日上午11：30下午16：30。
      </p>
      <p style="line-height: 150%">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.如因就诊人提供的信息不正确或未按时取号，导致预约就诊未成功，医院不承担任何责任。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "registrationInfo",
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
#info {
  background-color: #fff;
}

p {
  padding: 14px 14px 0;
  font-size: 16px;
}
</style>